export const breakpoints = {
	large: "1200px",
	medium: "1024px",
	medSmall: "860px",
	small: "768px",
	xSmall: "400px",
};
